import Lara from "@/presets/lara";

export const filterPillBarPresets = {
  ...Lara,
  tag: {
    ...Lara.tag,
    root: (args) => ({
      class: [
        "h-8",
        "flex",
        "flex-row-reverse",
        "items-center",
        "bg-gray-300",
        "rounded-full",
        "border",
        "border-gray-300",
        "py-[4px]",
        "pl-[12px]",
        "pr-[8px]",
        "text-sm",
        "font-medium",
        "text-university-primary",
        "cursor-pointer",
      ],
    }),
  },
  badge: {
    ...Lara.badge,
  },
};
